<template>
	<el-dialog title="提示"
	  :visible.sync="sizeDialogVisible"
	  :show-close="false"
	  :modal="false"
	  width="50%">
		<div slot="title">
			<div style="display: flex; flex-direction:row;justify-content:space-between;">
				<div>{{sizeDialog.quoteInfo}}</div>
			</div>
		</div>         
		<el-form :model="sizeDialogForm" ref="sizeDialogForm" label-width="80px">
			<el-row>
				<el-col :span="6">   
					<el-form-item label="单件实重" prop="realWeight" ref="sizeRealWeight">
						<el-input type="number" v-model.number="sizeDialogForm.realWeight" :disabled="sizeDialogForm.index==-1"></el-input>
					</el-form-item>                       
				</el-col>
				<el-col :span="6">   
					<el-form-item label="包装类型" prop="packageType" ref="sizePackageType">
                        <el-select v-model="sizeDialogForm.packageType" @change="packageTypeChange">
                            <el-option v-for="(item, key) in packageTypeOptions" :key="key" :label="item.label" :value="item.value"></el-option>
                        </el-select>
					</el-form-item>                       
				</el-col>				
				<el-col :span="6">            
					<el-form-item label="件数" prop="caseCount" ref="sizeCaseCount">
						<el-input type="number" v-model.number="sizeDialogForm.caseCount" :disabled="sizeDialogForm.index==-1"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6" style="display: flex;justify-content:flex-end;">
					<el-button type="primary" size="mini" style="width: 80%;" @click="removeVoucherSize">删除</el-button>            
				</el-col>                    
			</el-row>
			<el-row>
				<el-col :span="6">            
					<el-form-item label="长" prop="len" ref="sizeLen">
						<el-input type="number" v-model.number="sizeDialogForm.len" :disabled="sizeDialogForm.index==-1"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">            
					<el-form-item label="宽" prop="width" ref="sizeWidth">
						<el-input type="number" v-model.number="sizeDialogForm.width" :disabled="sizeDialogForm.index==-1"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">            
					<el-form-item label="高" prop="height" ref="sizeHeight">
						<el-input type="number" v-model.number="sizeDialogForm.height" :disabled="sizeDialogForm.index==-1"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6" style="display: flex;justify-content:flex-end;">
					<el-button type="primary" size="mini" style="width: 80%;" @click="btnSaveSizeClick">确定</el-button>            
				</el-col>
			</el-row>
		</el-form>
			<!-- :key="Math.random()" -->
		<el-table ref="sizeTable"
			:data="sizeDialog.voucherSizes" 
			:header-cell-style="{background:'#ecedeb',
										color: '#173686',
										border: '0',
									  }"
			:cell-class-name="sizeTableCellClassName"
			max-height="600"
			highlight-current-row
			border style="width: 100%"
			@current-change="sizeRowClick"
			>                
			<el-table-column
				label="单件实重"
				width="90"
				prop="realWeight">
			</el-table-column>
			<el-table-column
				label="包装类型"
				width="90"
				prop="packageTypeName">
			</el-table-column>			
			<el-table-column
				label="长"
				width="80"
				prop="len">               
			</el-table-column>
			<el-table-column
				label="宽"
				width="80"                    
				prop="width">        
			</el-table-column>
			<el-table-column
				label="高"
				width="80"                    
				prop="height">           
			</el-table-column>
			<el-table-column
				label="体积"
				width="80"                    
				prop="materialWeight">
			</el-table-column>
			<el-table-column
				label="件数"
				prop="caseCount">             
			</el-table-column>                                                                                            
		</el-table>           
		<div>
			件数{{sizeDialog.caseCount}},实重{{sizeDialog.realWeight}},体积重{{sizeDialog.materialWeight}},结算重{{sizeDialog.settlementWeight}}
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="sizeDialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="sizeDialogConfirm">确 定</el-button>
		</span>
	</el-dialog>	
</template>

<script>
	import * as string from '@/utils/string'		
	export default {
		props: {
			netQuote: {
				type: Object,
				default: () => null
			},
			voucher: {
				type: Object,
				default: () => null
			},
			packageTypeOptions: {
				type: Array,
				default: ()=>[]
			}
		},
		data(){
			return {
				sizeDialog:{
					voucherSizes:[],
					multiPiecesCalcRule: 2,
					volumeDiv: 5000,
					weightPercent: 0,
					goodsType: 1,
					caseCount: 0,
					realWeight: '新增',
					materialWeight: 0,
					settlementWeight: 0,
					quoteInfo: ''
				},
				sizeDialogVisible: false,
				sizeDialogForm:{
					index: -1,
					realWeight: 0,
					caseCount: 0,
					len: 0,
					width: 0,
					height: 0,
					packageType: 1
				},
				// packageTypeOptions:[
				// 	{label: '纸箱', value: 1},
				// 	{label: '木箱', value: 2},
				// 	{label: '航空箱', value: 3},
				// 	{label: '木架', value: 4},
				// ]
			}
		},
		methods: {
			open(){
				let jsonData = JSON.stringify(this.voucher.voucherSizes)
				console.log(jsonData)
				this.sizeDialog.voucherSizes = JSON.parse(jsonData)
				for(let voucherSize of this.sizeDialog.voucherSizes){
					voucherSize.packageTypeName = this.getPackageTypeName(voucherSize.packageType)
				}
				this.sizeDialog.voucherSizes.push({realWeight:'新增'})
				this.sizeDialog.caseCount = this.voucher.pieces
				this.sizeDialog.realWeight = this.voucher.realWeight
				this.sizeDialog.materialWeight = this.voucher.materialWeight
				this.sizeDialog.settlementWeight = this.voucher.settlementWeight
				if((this.netQuote != null) && this.netQuote.bizType){
					this.sizeDialog.multiPiecesCalcRule = (this.netQuote.bizType.toUpperCase().indexOf('UPS') != -1)?1:2
				}else{
					this.sizeDialog.multiPiecesCalcRule = 2
				}
				if(this.netQuote != null){
					this.sizeDialog.volumeDiv = this.netQuote.volumeDiv
					this.sizeDialog.weightPercent = this.netQuote.weightPercent            
				}else{        
					this.sizeDialog.volumeDiv = 5000
					this.sizeDialog.weightPercent = 0
				}
				this.sizeDialog.goodsType = typeof(this.voucher.goodsType)=='undefined'?1:this.voucher.goodsType
				if(this.sizeDialog.multiPiecesCalcRule == 1){
					this.sizeDialog.quoteInfo = '按件0.5进位,体积除' + this.sizeDialog.volumeDiv + ',分泡' + this.sizeDialog.weightPercent 
				}else{
					this.sizeDialog.quoteInfo = '按件不进位,体积除' + this.sizeDialog.volumeDiv + ',分泡' + this.sizeDialog.weightPercent            
				}
				this.sizeDialogVisible = true
				this.$nextTick(()=>{
					this.$refs.sizeTable.setCurrentRow(this.sizeDialog.voucherSizes[this.sizeDialog.voucherSizes.length - 1]);
				})
			},
			getPackageTypeName(packageType){
				if(this.packageTypeOptions != null){
					let option = this.packageTypeOptions.find(item=>item.value==packageType)
					return option?option.label:''
				}
				return ''
			},
			packageTypeChange(value){
				this.$forceUpdate()
			},
			sizeTableCellClassName({row, column, rowIndex, columnIndex}){
				  //注意这里是解构
				  //利用单元格的 className 的回调方法，给行列索引赋值
				  row.index=rowIndex;
				  column.index=columnIndex;
			},
			recalcVoucherSize(){
				let value = parseFloat(this.realWeightCalcValue)
				if(!Number.isNaN(value)){
					for(let voucherSize of this.sizeDialog.voucherSizes){
						if(voucherSize.realWeight != '新增'){
							if(this.realWeightCalcMethod == 0)
								voucherSize.realWeight = string.toFloat(voucherSize.realWeight * value, 3)
							else
								voucherSize.realWeight = string.toFloat(voucherSize.realWeight - value, 3)                        
						}
					}
				}
				value = parseFloat(this.sizeCalcValue)
				if(!Number.isNaN(value)){
					for(let voucherSize of this.sizeDialog.voucherSizes){
						if(voucherSize.realWeight != '新增'){
							if(this.sizeCalcMethod == 0){
								voucherSize.len = string.toFloat(voucherSize.len * value, 3)
								voucherSize.width = string.toFloat(voucherSize.width * value, 3)
								voucherSize.height = string.toFloat(voucherSize.height * value, 3)
							}else{
								voucherSize.len = string.toFloat(voucherSize.len - value, 3)
								voucherSize.width = string.toFloat(voucherSize.width - value, 3)
								voucherSize.height = string.toFloat(voucherSize.height - value, 3)                                                
							}   
							voucherSize.materialWeight = string.toFloat(Math.round(voucherSize.len * voucherSize.width * voucherSize.height / this.sizeDialog.volumeDiv * 1000) / 1000, 3)                    
						}
					}            
				}
				for(let voucherSize of this.sizeDialog.voucherSizes){
					if(voucherSize.realWeight != '新增'){
						this.calcVoucherSizeWeight(voucherSize)
					}
				}        
				this.calcSizeDialogSummary()        
			},
			sizeRowClick(row){
				if(row != null){
					this.sizeDialogForm = {...row}
					if(row.realWeight === '新增'){
						this.sizeDialogForm.realWeight = 0
						this.sizeDialogForm.packageType = 1
					}    
				}
			},
			calcSizeDialogSummary(){
				let caseCount = 0
				let realWeight = 0;
				let materialWeight = 0;
				let settlementWeight = 0
				for(let voucherSize of this.sizeDialog.voucherSizes){
					if(voucherSize.realWeight !== '新增'){
						 caseCount += parseInt(voucherSize.caseCount)
						 realWeight += voucherSize.realWeight * voucherSize.caseCount
						 materialWeight += voucherSize.materialWeight * voucherSize.caseCount
						 settlementWeight += voucherSize.settlementWeight * voucherSize.caseCount
					}
				}
				this.sizeDialog.caseCount = caseCount
				this.sizeDialog.realWeight = string.toFloat(realWeight, 3)
				this.sizeDialog.materialWeight = string.toFloat(materialWeight, 3)
				this.sizeDialog.settlementWeight = string.toFloat(settlementWeight, 2)
			},
			//根据长宽高，实重计算材积重和结算重
			calcVoucherSizeWeight(voucherSize){
				voucherSize.materialWeight = string.toFloat(Math.round(voucherSize.len * voucherSize.width * voucherSize.height / this.sizeDialog.volumeDiv * 1000) / 1000, 3)
				let settlementWeight = voucherSize.realWeight
				if((this.sizeDialog.goodsType == 1) && (voucherSize.materialWeight > voucherSize.realWeight)){
					settlementWeight = (voucherSize.materialWeight - voucherSize.realWeight) * (100 - this.sizeDialog.weightPercent) / 100 + voucherSize.realWeight
				}
				if(this.sizeDialog.multiPiecesCalcRule == 1){
					let intPart = Math.floor(settlementWeight)
					let decPart = settlementWeight - intPart
					if(decPart > 0){
						if(decPart > 0.5){
							settlementWeight = intPart + 1
						}else{
							settlementWeight = intPart + 0.5
						}
					}
				}else{
					settlementWeight = string.toFloat(settlementWeight, 2)  //按件不进位，取两位小数
				}
				voucherSize.settlementWeight = settlementWeight        
			},
			btnSaveSizeClick(){      
				this.$refs['sizeDialogForm'].validate((valid) => {
					if (valid) {             
						let voucherSize = {}
						voucherSize.len = string.toFloat(this.sizeDialogForm.len, 3)
						voucherSize.width = string.toFloat(this.sizeDialogForm.width, 3)
						voucherSize.height = string.toFloat(this.sizeDialogForm.height, 3)
						voucherSize.realWeight = string.toFloat(this.sizeDialogForm.realWeight, 3)
						voucherSize.caseCount = parseInt(this.sizeDialogForm.caseCount)
						voucherSize.packageType = this.sizeDialogForm.packageType
						voucherSize.packageTypeName = this.getPackageTypeName(this.sizeDialogForm.packageType)
						this.calcVoucherSizeWeight(voucherSize)
						this.$set(this.sizeDialog.voucherSizes, this.sizeDialogForm.index, voucherSize)
						this.calcSizeDialogSummary()
						this.sizeDialogForm = {index: -1}
						let newLineExists = false
						for(let voucherSize of this.sizeDialog.voucherSizes){
							if(voucherSize.realWeight === '新增'){
								newLineExists = true
								break
							}
						}
						if(!newLineExists){
							this.sizeDialog.voucherSizes.push({realWeight: '新增'})
						}
						this.$nextTick(()=>{
							this.$refs.sizeTable.setCurrentRow(this.sizeDialog.voucherSizes[this.sizeDialog.voucherSizes.length - 1]);
						})                
					} else {
							console.log('error submit!!');
							return false;
					}
				});
			},
			removeVoucherSize(){
				let idx = this.sizeDialogForm.index
				if(this.sizeDialog.voucherSizes[idx].realWeight !== '新增'){
					this.sizeDialog.voucherSizes.splice(idx, 1)
					this.calcSizeDialogSummary()            
					this.$nextTick(()=>{
						this.$refs.sizeTable.setCurrentRow(this.sizeDialog.voucherSizes[this.sizeDialog.voucherSizes.length - 1]);
					})             
				}
			},
			sizeDialogConfirm(){
				let l = this.sizeDialog.voucherSizes.length - 1
				if(this.sizeDialog.voucherSizes[l].realWeight === '新增'){
					this.sizeDialog.voucherSizes.splice(l, 1)
				}
				this.voucher.voucherSizes = this.sizeDialog.voucherSizes
				this.voucher.pieces = this.sizeDialog.caseCount
				this.voucher.realWeight = this.sizeDialog.realWeight
				this.voucher.materialWeight = this.sizeDialog.materialWeight
				this.voucher.settlementWeight = this.sizeDialog.settlementWeight
				this.sizeDialogVisible = false;
				this.$emit('close')
			}				
		}
	}
</script>

<style>
</style>
